import React from "react";
import {
  UtensilsCrossed,
  Pill,
  SprayCan,
  PawPrint,
  Factory,
  Leaf,
} from "lucide-react";

const ITEMS = [
  { label: "Food & Beverage", Icon: UtensilsCrossed },
  { label: "Nutraceuticals", Icon: Pill },
  { label: "Personal Care", Icon: SprayCan },
  { label: "Pet Food", Icon: PawPrint },
  { label: "Industrial", Icon: Factory },
  { label: "Eco / Compostable", Icon: Leaf },
];

export default function IndustriesStrip() {
  // duplicate items so the marquee can loop seamlessly
  const loop = [...ITEMS, ...ITEMS, ...ITEMS];
  return (
    <section
      id="industries"
      data-testid="industries-strip"
      className="border-y border-[#d1d5db] bg-[#1B3F8F] text-white overflow-hidden pk-ticker-pause"
    >
      <div className="relative">
        <div className="flex whitespace-nowrap pk-marquee py-5">
          {loop.map((it, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 px-8 text-[13px] md:text-sm font-bold uppercase tracking-[0.22em]"
            >
              <it.Icon size={18} className="text-[#F58220]" />
              <span>{it.label}</span>
              <span className="ml-8 text-[#F58220]">/</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
